module.exports = __webpack_public_path__ + "assets/valance-french.3a7c79fb.svg";